import { render, staticRenderFns } from "./TryMobileBanner.vue?vue&type=template&id=5d60c79f&"
import script from "./TryMobileBanner.vue?vue&type=script&lang=ts&"
export * from "./TryMobileBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBanner,QImg,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBanner,QImg,QIcon,QBtn})
